module.exports = __webpack_public_path__ + "static/media/img-slide-3@3x.3197aa53.png";